import { drawRoundRect } from "@gameApp/helpers/canvas/draw/rectRounded";
import { drawTextPure } from "@gameApp/helpers/canvas/draw/textPure";
import { getContextFont } from "@gameApp/helpers/canvas/getContextFont";
import { measureText } from "@gameApp/helpers/canvas/measureText";
import type { BasicDrawOptions } from "@gameApp/helpers/canvas/types";
import { MINI_GAME_CHARTS_ORDER_CHART_HEIGHT } from "@gameComponents/MiniGame/Charts/constants";
import { miniGamePriceFormat } from "@gameComponents/MiniGame/helpers/priceFormat";
import type { ScaleLinear } from "d3";
import colors from "tailwindcss/colors";

interface Params extends BasicDrawOptions {
  price: number;
  yScale: ScaleLinear<number, number>;
}

export function miniGameChartsDrawOrderEntryPrice(params: Params): void {
  const { context, yScale, price } = params;

  const entryPriceFormatted = miniGamePriceFormat(price);

  const { width: entryPriceWidth } = measureText(entryPriceFormatted, (ctx) => {
    ctx.font = getContextFont({ weight: 500, size: 12 });
  });

  const entryPriceBoxHeight = 20;
  const entryPriceBoxPaddingX = 4;
  const entryPriceY = yScale(price);
  const entryPriceBoxY = entryPriceY - entryPriceBoxHeight / 2;
  let entryPriceBoxShift = 0;

  if (entryPriceBoxY < 0) {
    entryPriceBoxShift = Math.abs(entryPriceBoxY);
  }

  if (
    entryPriceBoxY + entryPriceBoxHeight >
    MINI_GAME_CHARTS_ORDER_CHART_HEIGHT
  ) {
    entryPriceBoxShift =
      MINI_GAME_CHARTS_ORDER_CHART_HEIGHT -
      entryPriceBoxY -
      entryPriceBoxHeight;
  }

  context.save();

  drawRoundRect({
    context,
    x: 0,
    y: 0,
    translateX: 0,
    translateY: entryPriceY - entryPriceBoxHeight / 2 + entryPriceBoxShift,
    width: entryPriceWidth + entryPriceBoxPaddingX * 2,
    height: entryPriceBoxHeight,
    radius: 4,
    fill: true,
    stroke: false,
    contextOptions: {
      fillStyle: colors.gray[800],
    },
  });

  drawTextPure({
    x: 0,
    y: 0,
    context,
    translateX: entryPriceBoxPaddingX,
    translateY: entryPriceY + entryPriceBoxShift,
    text: entryPriceFormatted,
    contextOptions: {
      fillStyle: colors.white,
      font: getContextFont({ weight: 500, size: 12 }),
      textAlign: "left",
      textBaseline: "middle",
    },
  });

  context.restore();
}
